import { render, staticRenderFns } from "./SquareBox.vue?vue&type=template&id=363a5697&scoped=true&"
import script from "./SquareBox.vue?vue&type=script&lang=js&"
export * from "./SquareBox.vue?vue&type=script&lang=js&"
import style0 from "./SquareBox.vue?vue&type=style&index=0&id=363a5697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a5697",
  null
  
)

export default component.exports